import { styled } from 'baseui';
export const Description = styled('div', () => ({
  paddingLeft: '10px',
  fontSize: '14px'
}));
export const Row = styled('div', () => ({
  display: 'flex',
  margin: '5px',
  padding: '5px'
}));
export const HotkeyRow = styled('div', () => ({
  display: 'flex'
}));
export const Symbol = styled('div', () => ({
  paddingLeft: '5px'
}));